module.exports = __webpack_public_path__ + "static/media/gmw-standard.5fbbe505.png";